module.exports = __webpack_public_path__ + "img/icons/spreadsheet-d55af6dde7ca50d41308e1c3bfef2d66.svg";